import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';

export const useKey = () => {
  const location = useLocation();
  const [ key, setKey ] = useState("")
  const [searchParams] = useSearchParams();

  useEffect(() => {
    try {
      const key = searchParams.get('key');
      setKey(key)
    } catch (error) {
      console.error('Error setting key:', error);
    } finally {
      // console.log('Key set vroom vrooom.');
    }
  }, [location, setKey]);

  return { key };
};
